
function MultiChoice({ filter, handleOptionChanged, columns = 1 }) {

    // const [_, forceUpdate] = useReducer((x) => x + 1, 0)

    const toggleAllOptionsSelect = () => {
        var checked = 0
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            checked += item.selected ? 1 : 0
        }
        if (checked == filter.items.length) {
            filter.allselected = false
            for (var i = 0; i < filter.items.length; i++) {
                var item = filter.items[i]
                item.selected = false
            }
        }
        else {
            filter.allselected = true
            for (var i = 0; i < filter.items.length; i++) {
                var item = filter.items[i]
                item.selected = true
            }
        }
        // console.log('toggleAll checked', checked, filter)
        // forceUpdate()
        handleOptionChanged(filter, null)
    }

    const selectServes = () => {
        filter.allselected = false
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            item.selected = (i >= 0 && i < 4)
        }
        handleOptionChanged(filter, null)
    }

    const selectReturns = () => {
        filter.allselected = false
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            item.selected = (i > 3 && i <= 7)
        }
        handleOptionChanged(filter, null)
    }

    const toggleOptionSelect = (item) => {
        item.selected = !item.selected
        // console.log('Item, Option', item, filter)
        var checked = 0
        for (var i = 0; i < filter.items.length; i++) {
            var item = filter.items[i]
            checked += item.selected ? 1 : 0
        }
        filter.allselected = (checked == filter.items.length)
        handleOptionChanged(filter, item)
    }

    // console.log('MultiChoice', filter)
    return (
        <div>
            <div className="options-list-item pb-1 pl-1">
                {/* <div className="left-section">
                    <input
                        key={Math.random()}
                        type="checkbox"
                        id={`custom-checkbox-${1000}`}
                        name={filter.title}
                        value={filter.title}
                        defaultChecked={filter.allselected}
                        onChange={() => toggleAllOptionsSelect()}
                    />
                    <label className='font-semibold text-center text-base-700'>{filter.title.toUpperCase()}</label>
                </div> */}
                <div className="flex flex-col">
                    {
                        filter.title == "Shots" ?
                            <div className="flex space-x-4 pt-4">
                                <button className="flex btn-ghost btn-xs rounded-none" onClick={() => selectServes()}>All Srvs</button>
                                <button className="flex btn-ghost btn-xs rounded-none" onClick={() => selectReturns()}>All Returns</button>
                            </div> : null
                    }
                </div>
            </div>
            <ul
                className="px-2 grid gap-x-2"
                style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
            >
                {filter.items.map((item, index) => {
                    // Multiple MultiChoice instances render at once (one per filter), so
                    // the id must include the filter title too — otherwise every filter's
                    // Nth checkbox shares the same id and a label click toggles whichever
                    // one happens to be first in the DOM (column 1) instead of its own.
                    const checkboxId = `custom-checkbox-${(filter.title ?? "filter").replace(/\s+/g, "-")}-${index}`;
                    return (
                        <li key={index}>
                            <div className="options-list-item pb-1">
                                <div className="left-section">
                                    <input
                                        key={Math.random()}
                                        type="checkbox"
                                        id={checkboxId}
                                        name={item.name}
                                        value={item.name}
                                        defaultChecked={item.selected}
                                        onChange={() => toggleOptionSelect(item)}
                                    />
                                    <label className='ml-2 text-base-400 text-[11px]' htmlFor={checkboxId}>{(item.name ?? "").toUpperCase()}</label>
                                </div>
                                <div className="right-section text-red-700 text-xs">{item.amount > 0 ? item.amount : ""}</div>
                            </div>
                        </li>
                    );
                })}
                <li style={{ gridColumn: "1 / -1" }}>
                    <div className="options-list-item">
                        {/* <div className="left-section">Total:</div>
                        <div className="right-section">{10}</div> */}
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default MultiChoice